import { useTheme } from '../context/ThemeContext';

// Logo component that switches based on dark/light mode
const Logo = ({ className = "", size = "md" }) => {
  const { isDark } = useTheme();
  
  const sizeClasses = {
    sm: "w-10 h-10",
    md: "w-16 h-16",
    lg: "w-20 h-20",
    xl: "w-24 h-24",
  };
  
  return (
    <img 
      src={isDark ? "/logo-dark.png" : "/logo-light.png"}
      alt="Reshapers"
      className={`${sizeClasses[size] || sizeClasses.md} rounded-2xl ${className}`}
    />
  );
};

export default Logo;
